import styled from '@emotion/styled'

import { mediaUp } from '@/styles/media'

export const InputWrapper = styled.span`
  display: block;
  position: relative;
`

export const IconWrapper = styled.span`
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);

  svg {
    display: block;
    width: 10px;
    fill: var(--neutral);

    ${mediaUp('lg')} {
      width: 16px;
    }
  }

  ${mediaUp('lg')} {
    right: 40px;
  }

  html[lang^='ar'] & {
    right: unset;
    left: 18px;

    ${mediaUp('lg')} {
      left: 40px;
    }
  }
`
